import React, { useState, useEffect, useRef } from "react";
import CheckBoxSelect from "./CheckBoxSelect";
import {
	NavigationSharp,
	ApartmentSharp,
	StoreSharp,
	PostAddSharp,
} from "@mui/icons-material";
import { RiResetLeftLine } from "react-icons/ri";
import { Tooltip } from "antd"; // make sure this import is present
import { use } from "react";
import { useTranslation } from "react-i18next";

const SearchHeader = ({
	setReset,
	setSelectedCountryData,
	selectedCountryData,
	country,
	setSelectedCity,
	selectedCity,
	city,
	setSelectedCompanyData,
	selectedCompanyData,
	companyList,
	setSelectedDesignationData,
	selectedDesignationData,
	designationList,
}) => {
	const [filtersChanged, setFiltersChanged] = useState(false);
	const [initialValues, setInitialValues] = useState({
		country: [],
		city: [],
		company: [],
		designation: [],
	});
	const hasUserModified = useRef(false);
    const { t } = useTranslation();
	const countryOptions = country?.map((val) => ({
		label: `${val.name} [${val.itemCounts}]`,
		value: val.id,
	}));
	const cityOptions = city?.map((val) => ({
		label: `${val.name} [${val.itemCounts}]`,
		value: val.id,
	}));
	const companyListOptions = companyList?.map((val) => ({
		label: `${val.name} [${val.itemCounts}]`,
		value: val.id,
	}));
	const designationListOptions = designationList?.map((val) => ({
		label: `${val.name} [${val.itemCounts}]`,
		value: val.id,
	}));

	// Set initial selected values when options are available
	useEffect(() => {
		if (
			countryOptions?.length &&
			cityOptions?.length &&
			companyListOptions?.length &&
			designationListOptions?.length &&
			initialValues.country.length === 0
		) {
			const initVals = {
				country: countryOptions.map((c) => c.value),
				city: cityOptions.map((c) => c.value),
				company: companyListOptions.map((c) => c.value),
				designation: designationListOptions.map((c) => c.value),
			};
			setInitialValues(initVals);
			setSelectedCountryData(initVals.country);
			setSelectedCity(initVals.city);
			setSelectedCompanyData(initVals.company);
			setSelectedDesignationData(initVals.designation);
		}
	}, [countryOptions, cityOptions, companyListOptions, designationListOptions]);

	// Compare logic to trigger filter change flag
	const compareArrays = (arr1, arr2) => {
		if (arr1.length !== arr2.length) return true;
		const set1 = new Set(arr1);
		return arr2.some((item) => !set1.has(item));
	};

	useEffect(() => {
		if (!hasUserModified.current) return;
		const isFilterChanged =
			compareArrays(selectedCountryData, initialValues.country) ||
			compareArrays(selectedCity, initialValues.city) ||
			compareArrays(selectedCompanyData, initialValues.company) ||
			compareArrays(selectedDesignationData, initialValues.designation);

		setFiltersChanged(isFilterChanged);
	}, [selectedCountryData, selectedCity, selectedCompanyData, selectedDesignationData, initialValues]);

	const handleChange = (setSelectedFn) => (val) => {
		hasUserModified.current = true;
		setSelectedFn(val);
		setReset(true);
	};

	return (
		<div className="d-block d-md-flex jobSearch jobdropdown mb-2">

			<div className="col-md-3 mb-1 search-dropdown search-cont pt-0">
				{/* <h6 className="ps-3">Country :</h6> */}
				<CheckBoxSelect
					icon={<NavigationSharp className="material-symbols-sharp me-1" />}
					placeholder={t("SearchJob.Select Country")}
					options={countryOptions}
					selectedValues={selectedCountryData}
					onChange={handleChange(setSelectedCountryData)}
				/>
			</div>
			<div className="col-md-3 mb-1 search-dropdown">
				<CheckBoxSelect
					icon={<ApartmentSharp className="material-symbols-sharp me-2" />}
					placeholder={t("SearchJob.Select City")}
					options={cityOptions}
					selectedValues={selectedCity}
					onChange={handleChange(setSelectedCity)}
				/>
			</div>
			<div className="col-md-3 mb-1 search-dropdown">
				<CheckBoxSelect
					icon={<StoreSharp className="material-symbols-sharp me-2" />}
					placeholder={t("SearchJob.Select Company")}
					options={companyListOptions}
					selectedValues={selectedCompanyData}
					onChange={handleChange(setSelectedCompanyData)}
				/>
			</div>
			<div className="col-md-3 mb-1 search-dropdown">
				<CheckBoxSelect
					icon={<PostAddSharp className="material-symbols-sharp me-2" />}
					placeholder={t("SearchJob.Select Designation")}
					options={designationListOptions}
					selectedValues={selectedDesignationData}
					onChange={handleChange(setSelectedDesignationData)}
				/>
			</div>
			<div className="col-md-3 mb-1 clearFilter">
				<div className="clear-all-filter-cont">
					<Tooltip title={t("SearchJob.Reset")} placement="bottom">
						<span>
							<RiResetLeftLine
								style={{
									opacity: filtersChanged ? 1 : 0.5,
									color: filtersChanged ? "var(--text-color2)" : "gray",
									fontSize: 24,
									cursor: filtersChanged ? "pointer" : "default",
								}}
								onClick={() => {
									if (!filtersChanged) return;
									setSelectedCountryData(initialValues.country);
									setSelectedCity(initialValues.city);
									setSelectedCompanyData(initialValues.company);
									setSelectedDesignationData(initialValues.designation);
									setReset(true);
									hasUserModified.current = false;
									setFiltersChanged(false);
								}}
							/>
						</span>
					</Tooltip>
				</div>
			</div>
		</div>
	);
};

export default SearchHeader;

